<template>
  <global-tag>
    <el-form
      class="queryForm"
      ref="queryForm"
      :model="queryForm"
      label-width="120px"
    >
      <el-row>
        <el-col :span="5">
          <el-form-item label="客户姓名：">
            <el-input
              clearable
              v-model="queryForm.customerName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="用户类型：">
            <el-select
              v-model="queryForm.customerUserType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in userType"
                :key="index"
                :label="item.dictLabel"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label="服务项目：">
            <el-select
              v-model="queryForm.serveproductName"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in product"
                :key="item.id"
                :label="item.serviceProductName"
                :value="item.id + ''"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label="机构：">
            <el-select
              v-model="queryForm.servestationName"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in serviceStationList"
                :key="item.id"
                :label="item.statName"
                :value="item.statName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="服务人员：">
            <el-input
              clearable
              v-model="queryForm.servePersonName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
           <el-form-item label="服务类型：">
            <el-select
              v-model="queryForm.serviceTypeName"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in serviceTypeList"
                :key="item.id"
                :label="item.serviceTypeName"
                :value="item.serviceTypeName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="工单号：">
            <el-input
              clearable
              v-model="queryForm.orderNum"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18" v-if="queryForm.finish == 1">
          <el-form-item v-if="queryForm.finish == 1">
            <span>当月工单数大于</span>
            <el-input
              style="width: 25%; margin: 0 5px"
              v-model="queryForm.startCount"
              placeholder="请输入"
              type="number"
            ></el-input>
            次，并且小于
            <el-input
              v-model="queryForm.endCount"
              style="width: 25%; margin: 0 5px"
              type="number"
              @blur="Count"
              placeholder="请输入"
            ></el-input>
            次工单
          </el-form-item>
        </el-col>
        <el-col :span="2" class="QuerySearchBtn">
          <el-button
            size="medium"
            class="searchBtns"
            type="primary"
            @click="QuerySearch"
            >查询
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </global-tag>
</template>
<script>
import request from "@/utils/request"
import globalTag from "@/component/globalTag"

export default {
  name: "queryForm",
  components: { globalTag },
  props: {
    queryForm: {
      type: Object,
    },
  },
  data() {
    return {
      //客户下拉框的值
      options: [
        {
          value: "7",
          label: "商业客户",
        },
        {
          value: "3",
          label: "残联客户",
        },
        {
          value: "4",
          label: "老干客户",
        },
        {
          value: "6",
          label: "民政客户",
        },
        {
          value: "10",
          label: "文明办客户",
        },
      ],
      serviceTypeList:[
      ],
      product: [],
      serviceStationList: [],
      serviceStaffList: [],
      userType: [],
    }
  },
  created() {
    this.getTableData()
    this.getServiceStationList()
    // this.getServiceStaffList()
    this.getusertypeList()
    this.getTypeList()
  },
  methods: {
    //获取服务类别
    getTypeList(){
       request({
        url: "/jjyl/admin/type/info/findList1",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          states: "1",
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content || []
          this.serviceTypeList=res.content
        }
      })
    },
    //获取用户类型
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "usertype",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.userType = res.rows
            }
          }
        })
    },
    Count() {
      if (this.queryForm.endCount < this.queryForm.startCount) {
        this.queryForm.endCount = ""
        this.$message("后者输入的次数应大于前者")
      }
    },
    QuerySearch() {
      let aa = this.queryForm.endCount - this.queryForm.startCount
      if (aa < 2) {
        this.queryForm.startCount = ""
        this.queryForm.endCount = ""
        this.$message("两次输入的次数不能连续")
      }
      this.$emit("QuerySearch")
    },

    // 获取项目列表数据
    getTableData() {
      this.$http
        .request({
          url: "/jjyl/admin/product/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 999,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.product = []
              this.pageConfig.total = 0
            } else {
              this.product = res.content.list || []
            }
          }
        })
    },
    // 机构
    getServiceStationList() {
      let params = {
        pageNo: 1,
        pageSize: 999,
      }
      request({
        url: "/jjyl/admin/serviceStation/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.serviceStationList = res.content.list || []
          } else {
            this.serviceStationList = []
          }
        }
      })
    },
    // 人员
    // 获取表格数据
    getServiceStaffList() {
      let params = {
        pageNo: 1,
        pageSize: 999,
        serviceStationName: this.queryForm.servestationName,
        // ...this.query,
      }
      this.$http
        .request({
          url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.serviceStaffList = []
              return
            }
            this.serviceStaffList = res.content.list
          }
        })
    },
  },
}
</script>
<style lang="less" scoped>
.QuerySearchBtn {
  margin-left: 60px;
}
</style>
